import { graphql } from "@/gql";
import { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";

export type InvoiceListItem = ResultOf<
  typeof invoiceListQuery
>["invoices"]["data"][number];
export type InvoiceListQueryVariables = VariablesOf<typeof invoiceListQuery>;
export const invoiceListQuery = graphql(`
  query InvoiceListQuery(
    $search: String
    $page: Int
    $first: Int!
    $status: [InvoiceStatus!]
    $whereWorkOrder: QueryInvoicesWhereWorkOrderWhereHasConditions
    $where: QueryInvoicesWhereWhereConditions
    $managedById: ID
    $payeeContactId: ID
    $orderBy: [QueryInvoicesOrderByOrderByClause!]
    $supplierId: ID
  ) {
    invoices(
      first: $first
      page: $page
      search: $search
      where: $where
      whereWorkOrder: $whereWorkOrder
      payee_contact_id: $payeeContactId
      managed_by_id: $managedById
      orderBy: $orderBy
      status: $status
      supplier_id: $supplierId
    ) {
      data {
        id
        uuid
        reference
        amount_inc_tax
        due_date
        invoice_date
        status
        currency
        managedBy {
          id
          name
        }
        payee {
          id
          name
        }
        created_at
        updated_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
